export function AvatarCanvas() {
  return (
    <div className="portrait-3d">
      <canvas id="avatarCanvas" aria-label="ARIA point cloud avatar" />
      <div className="model-loader">
        <div>
          <span>Loading point cloud</span>
          <span className="pct">0%</span>
        </div>
      </div>
      <div className="p-layer p-ring" aria-hidden="true" />
    </div>
  )
}
